import React from "react";
import PropTypes from "prop-types";
import I18n from "lib/i18n";

const AdminMenuEntries = ({ adminActions }) => {
  if (!adminActions.length) {
    return null;
  }

  const actions = adminActions.map(({ path, label, icon }) => {
    const iconElement = icon ? <i className={`icon-${icon}`} /> : null;

    return (
      <li key={path}>
        <a href={path}>{iconElement}{label}</a>
      </li>
    );
  });

  return (
    <React.Fragment>
      <li>
        <hr />
        <h4>{I18n.t("top_bar.label.admin")}</h4>
      </li>
      {actions}
    </React.Fragment>
  );
};

AdminMenuEntries.propTypes = {
  adminActions: PropTypes.arrayOf(PropTypes.shape({
    path: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    icon: PropTypes.string,
  })).isRequired,
};

export default AdminMenuEntries;
